// extracted by mini-css-extract-plugin
export var uploadcontrolbox = "upload-module--uploadcontrolbox--7da52";
export var uploadcontrolboxcancel = "upload-module--uploadcontrolboxcancel--e5ee9";
export var uploadcontrolboxmessage = "upload-module--uploadcontrolboxmessage--bffca";
export var uploadimageconfirm = "upload-module--uploadimageconfirm--812b8";
export var uploadimageholder = "upload-module--uploadimageholder--86b68";